
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexWHKSrrgMGlJX79US22pANCc4BssJ9vSBmq1GnnKTIjkMeta } from "/tmp/tmp_420i31x/pages/index.vue?macro=true";
import { default as indexXt6QvDxG2TfRfyCbyBs2eXDOGuS5q6NiuTbvoW51BeAMeta } from "/tmp/tmp_420i31x/pages/[area]/index.vue?macro=true";
import { default as indexN37iHC8V3Jt3LdgYdRhOrfOybzk4KxrMWV3VWqJQWiYMeta } from "/tmp/tmp_420i31x/pages/okinawa/index.vue?macro=true";
import { default as indexytBAwK5I9RMr4QtXx_459q7Q5GFlzNMEMWRW_TLcyKz6gMeta } from "/tmp/tmp_420i31x/pages/zoom-map/index.vue?macro=true";
import { default as indexecEKhWqRHemkTXljrqCsA6Sl4GcAYlMFmwCEQq5YVF8Meta } from "/tmp/tmp_420i31x/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexWXy7TINBXXCiMU0uc0RrJWFkz3VlZwjyTFzH_mB16YMMeta } from "/tmp/tmp_420i31x/pages/[area]/[pref]/index.vue?macro=true";
import { default as indextTbao2CHVq2d6__KAhObCpXSQwBH8ASgMCcUR3KNqFgMeta } from "/tmp/tmp_420i31x/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmp_420i31x/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmp_420i31x/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmp_420i31x/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmp_420i31x/pages/zoom-map/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmp_420i31x/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmp_420i31x/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmp_420i31x/pages/[area]/[pref]/[id]/index.vue")
  }
]